/**
 * ИНН работодателя по названию (сверка «Айнбиндер», 26.10.2026: в заявлении
 * не было ИНН работодателя). В трудовой и ИЛС ИНН не пишут, поэтому — поиск
 * организации в DaData. Наружу уходит только название организации, данных
 * должника в запросе нет. Организации из города (региона) регистрации
 * должника — первыми: «Детский сад № 29» есть во многих городах.
 */

import { useState } from 'react';
import { api, type PartySuggestion } from '../../../api.js';

const key = (value: string) => value.toLowerCase().replace(/ё/g, 'е');

export function EmployerInnSearch({
  employerName,
  hometown,
  readOnly,
  onPick,
}: {
  employerName: string;
  /** Город и субъект из адреса регистрации — для порядка в списке */
  hometown: string[];
  readOnly: boolean;
  onPick: (inn: string) => void;
}) {
  const [busy, setBusy] = useState(false);
  const [found, setFound] = useState<PartySuggestion[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  const search = async () => {
    setBusy(true);
    setError(null);
    try {
      const { enabled, suggestions } = await api.dadata.party(employerName.trim());
      if (!enabled) return setError('Поиск организаций недоступен — впишите ИНН вручную.');
      const local = (s: PartySuggestion) => hometown.some((place) => place && key(s.entry.address).includes(key(place)));
      setFound([...suggestions.filter(local), ...suggestions.filter((s) => !local(s))]);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  };

  if (readOnly || !employerName.trim()) return null;
  return (
    <div className="inn-search">
      <button type="button" className="link-button" disabled={busy} onClick={() => void search()}>
        {busy ? 'Ищу…' : 'Найти ИНН по названию'}
      </button>
      {error && <p className="error-text">{error}</p>}
      {found && found.length === 0 && <p className="hint">Организация не найдена — впишите ИНН вручную.</p>}
      {found && found.length > 0 && (
        <ul className="suggestions-list">
          {found.map((s) => (
            <li key={s.entry.inn}>
              <button
                type="button"
                className="link-button"
                onClick={() => {
                  onPick(s.entry.inn);
                  setFound(null);
                }}
              >
                {s.entry.name}, ИНН {s.entry.inn}
              </button>
              <div className="hint">
                {s.entry.address}
                {s.warning && <span className="warning"> — {s.warning}</span>}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
